import React , {useState , useEffect} from 'react'
import ImageComponents from '../../../../Shared/ImageComponents';
import { Link,Button,TextField } from '@mui/material';
import Loader from '../../Components/loader';
import CardValidator from '../../Components/cardValidator';

function CardlessEmiDetails({cardlessBankList , mode , secret , amountToBePaid }) {

  const [codeList , setcodeList] = useState([]);
  const [selectBankCode, setBankCode] = useState('');
  const [NBerror, setNBerror] = useState(false);
  const [txnurl , settxnurl ] = useState('');
  const [pgpayload , setpgpayload] = useState('');
  const [showLoader, setshowLoader] = useState(false);
  const [mobileNumber , setMobileNumber] = useState('');
  const [mobileNumberError , setMobileNumberError] = useState('');
   let form;
   let modeType;
   let encryptedMob;
   const modeToPass = 'CARDLESS_EMI';
   
   
  const handleCardNumberClick = () => {
    setMobileNumberError('');
  };
   
   const handleMobileNumberChange =  (event) => {
     const value = event.target.value;
     const sanitizedValue = value.replace(/\D/g, '').slice(0, 12);
     setMobileNumber(sanitizedValue);	
   };

    const queryParameters = new URLSearchParams(window.location.search);
    let orderNo = queryParameters.get("orderNo");
  
  const handleChange = (event) => {
    setNBerror(false);
    const selectedBankCode = event.target.value;
    setBankCode(selectedBankCode);
  };
useEffect(() => {
   setcodeList(cardlessBankList);
  }, [cardlessBankList]); 
  
  const handlePayNow = async () => {
    let isValid = true;
    const needsMobileEligibility = selectBankCode === '241' || selectBankCode === '480';

    if (needsMobileEligibility) {
      if (/^[1-9][0-9]{4,14}$/.test(mobileNumber)) {
        setshowLoader(true);
        const validates = new CardValidator();
        encryptedMob = encodeURIComponent(validates.encrypt(mobileNumber, secret).toString());
        const postData = JSON.stringify({
          orderNo: orderNo,
          custAmount: amountToBePaid,
          custMob: encryptedMob,
          gateway: selectBankCode === '480' ? 'payu' : 'shopSe',
        });

        try {
          const response = await fetch('/pay/emi/shopSe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: postData,
          });

          const data = await response.json();

          if (data.status) {
            setshowLoader(false);
          } else {
            setshowLoader(false);
            isValid = false;
            alert('Not eligible for EMI');
          }
        } catch (error) {
          isValid = false;
          console.error('Error:', error);
        } finally {
          setshowLoader(false);
        }
      } else {
        isValid = false;
        setshowLoader(false);
        setMobileNumberError('Please enter valid mobile number');
      }
    }

    if (isValid) {
    if(selectBankCode > 0){
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    if(mode === 'EMI'){
     modeType = "EMI_CARDLESS";
    }
    if(mode === 'NCEMI'){
     modeType = "NCEMI_CARDLESS";
    }
    if(mode === 'lowCostEMI'){
     modeType = "lowcostemicardless";
    }

    try {
      const response = await fetch('/pay/securePayment/process/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: modeToPass,
          modeType: modeType,
          emiBankId : selectBankCode,
          custMobi : encryptedMob
        })
      });
      const data = await response.json();
      
      if(data.as ===1){
      if(data.pgPayload.form){
      const formHtml = data.pgPayload.form;
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = formHtml;
      const formElement = tempContainer.querySelector('form');
      document.body.appendChild(formElement);
      setshowLoader(false);
      formElement.submit();
      }
      else if(data.txnURL){
       settxnurl(data.txnURL);
       setpgpayload(data.pgPayload);
       await delay(1500);
       form = document.getElementById('testForm');
       form.submit();
      }  }else if(data.as ===2){
       window.location.href = data.txnURL1;
      
      }else if(data.error === 1){
        window.location.reload();      
        }  
         } catch (error) {
        setshowLoader(false);
        console.error('Error:', error);
        
    }
    }else{
    setNBerror(true);
    }
    }
    } 
  
  
  useEffect(() => {
    if (selectBankCode) {
      setNBerror(false);
      setMobileNumberError('');
    }
  }, [selectBankCode]); 
  
const delay = millis => new Promise((resolve, reject) => {
  setTimeout(_ => resolve(), millis)
});
  
  return (
  <>
   {showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
   {pgpayload && (
    <form method="post" action={txnurl} id="testForm">
        {Object.keys(pgpayload).map((key, index) => (
            <input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
        ))}
    </form>
)}
  	
    <div className='cardless-emi-box'>
        <ul>

            {codeList && Array.isArray(codeList) && codeList.map((code) => {
              const meta = {
                '236': { img: 'Axio', label: 'Axio' },
                '80': { img: 'BajajFinserv', label: 'Bajaj Finserv' },
                '241': { img: 'ShopSe', label: 'ShopSe' },
                '232': { img: 'EarlySalary', label: 'Early Salary' },
                '242': { img: 'Paytm', label: 'Paytm Postpaid' },
                '480': { img: 'LazyPay', label: 'LazyPay' }
              }[String(code)];
              if (!meta) return null;
              return (
                <li
                  key={code}
                  className={selectBankCode === String(code) ? 'active' : ''}
                  onClick={() => {
                    setBankCode(String(code));
                    setMobileNumberError('');
                  }}
                >
                  <Link>
                    <ImageComponents name={meta.img} /> <span>{meta.label}</span>
                  </Link>
                </li>
              );
            })}

            {(selectBankCode === '241' || selectBankCode === '480') && (
              <>
                <div className="py-2">Customer Mobile (Number linked to Aadhar is preferred)</div>
                <TextField
                  fullWidth
                  type="text"
                  placeholder="Enter your mobile number"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  error={Boolean(mobileNumberError)}
                  helperText={mobileNumberError}
                  onClick={handleCardNumberClick}
                />
              </>
            )}
            <li>
             {NBerror && (
      <p style={{ color: 'red' }}>Please select a bank!</p>
    	)}	
    	 
    	
                <Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
                    Continue
                </Button>
            </li>
        </ul>
      
    </div>
    </>
  )
}

export default CardlessEmiDetails
